import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-static-filter", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("static-filter", "static-filter-with-select"),
            componentTag: "ux-static-filter",
            performActions: async (page) => {
                await page.waitForSelector("ux-icon[name='chevron-down'] svg");
                await page.waitForSelector("ux-icon[name='cart'] svg");
            },
        });
    });
});
